import React from 'react';

interface StatusBadgeProps {
  status: string;
}

const statusStyles: Record<string, { label: string; color: string }> = {
  pending: { label: 'Pending', color: 'bg-[#FFF6D3] text-[#E6BB20]' },
  approved: { label: 'Approved', color: 'bg-green-100 text-green-600' },
  rejected: { label: 'Rejected', color: 'bg-red-50 text-red-600' },
  successful: { label: 'Successful', color: 'bg-green-100 text-green-600' },
  failed: { label: 'Failed', color: 'bg-red-50 text-red-600' },
  new: { label: 'New', color: 'bg-green-100 text-green-600' },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const { label, color } = statusStyles[status] || {
    label: 'Unknown',
    color: 'bg-gray-100 text-gray-600',
  };

  return (
    <span className={`text-xs px-2 py-1 rounded-md w-fit ${color}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
